const CustomDivider = ({disabled = false}) => {

    return (<div style={{ 
        "backgroundImage": "linear-gradient(to right, #333 40%, rgba(255, 255, 255, 0.5) 0%)",
        ...(disabled && {"backgroundImage": "none"}),
        "backgroundPosition": "center center",
        "backgroundSize": "9px 1px",
        "backgroundRepeat": "repeat-x",
        "padding" : "10px 50px",
        "margin" : "0 5px",
    }} />
    )
}

export default CustomDivider